import { FC, ReactElement, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { LoginRequestSchema, UsersService } from "../sdk"
import Button from "../components/Button"
import Card from "../components/Card"
import Col from "../components/Col"
import Icon from "../components/Icon"
import Input from "../components/Input"
import InputPassword from "../components/InputPassword"
import Row from "../components/Row"
import useAuth from "../hooks/useAuth"
import useError from "../hooks/useError"
import { toast } from "react-toastify"

const Login: FC = () => {
  const [loading, setLoading] = useState<boolean>(false)

  const { onLogin } = useAuth()
  const { handleError } = useError()
  const { control, formState, handleSubmit } = useForm<LoginRequestSchema>()

  const onSubmit = async(formData: LoginRequestSchema): Promise<void> => {
    setLoading(true)

    try {
      const { data } = await UsersService.login(formData)

      if (data.user.admin) {
        onLogin(data)
      } else {
        toast.error("L'utente non ha i permessi da amministratore")
        setLoading(false)
      }
    } catch (err) {
      handleError(err)
      setLoading(false)
    }
  }

  return (
    <div className={"container h-full items-center grid grid-cols-12 px-4 sm:px-6 lg:px-8"}>
      <Col lg={4} className="lg:col-start-5">
        <Row justify="center" className="mb-4">
          <Icon name="logo" size={40} />
        </Row>

        <Card>
          <h1 className="text-xl font-bold text-center">Login</h1>

          <p className="mt-1 mb-4 text-sm text-gray-400 text-center">Inserisci le credenziali per accedere alla dashboard</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name="emailOrUsername"
              control={control}
              rules={{
                required: "Campo obbligatorio"
              }}
              defaultValue=""
              render={({ field: { onChange, value } }): ReactElement => (
                <Input
                  className="mb-2"
                  label="Email o username"
                  value={value}
                  onChange={onChange}
                  error={formState.errors.emailOrUsername?.message}
                />
              )}
            />

            <Controller
              name="password"
              control={control}
              rules={{
                required: "Campo obbligatorio"
              }}
              defaultValue=""
              render={({ field: { onChange, value } }): ReactElement => (
                <InputPassword
                  label="Password"
                  value={value}
                  onChange={onChange}
                  error={formState.errors.password?.message}
                />
              )}
            />

            <Row className="mt-4" justify="center">
              <Button type="submit" disabled={loading}>Login</Button>
            </Row>
          </form>
        </Card>
      </Col>
    </div>
  )
}

export default Login
